import { render, staticRenderFns } from "./process4.vue?vue&type=template&id=47218669&scoped=true&"
import script from "./process4.vue?vue&type=script&lang=js&"
export * from "./process4.vue?vue&type=script&lang=js&"
import style0 from "./process4.vue?vue&type=style&index=0&id=47218669&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47218669",
  null
  
)

export default component.exports